import { ExpandMore } from "@mui/icons-material";
import { Alert, Avatar, Box, Card, CardContent, Collapse, Grid, Hidden, Icon, IconButton, LinearProgress, Link, List, ListItemButton, ListItemIcon, ListItemText, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import { Outlet, useNavigate, useParams } from "react-router-dom";
import { FormTemplateTypeEnum } from "../../_common/enum/forms/fomTemplateType.enum";
import { IUserCartData } from "../../_common/interface/userCart/iUserCartList";
import { IUserProfileManage } from "../../_common/interface/users/iUserProfileManage";
import { LIGHT_GREY_COLOR, ORANGE_COLOR, PRIMARY_COLOR } from "../../_const/color.const";
import { getDate, getFutureDate } from "../../_helpers/dateTime.helper";
import { getMoneyFormat } from "../../_helpers/format.helper";
import { handleErrorResponse } from "../../_helpers/handleResponse.helper";
import { accountService } from "../../_services/accounts.service";
import { formTemplateService } from "../../_services/formTemplate.service";
import { userInformationService } from "../../_services/userInformation.service";
import { InfoManageLicenseButton } from "./user-infoManageLicenseButton";
import { UserProfilePageLicenseList } from "./user-profilePageLicenseList";
import { FormStatusEnum } from "../../_common/enum/forms/formStatus.enum";

var QRCode = require('qrcode')

export function UserProfilePage2() {

    const { userId, licenseType } = useParams<{ userId: string, licenseType: string }>();

    let navigate = useNavigate();

    const resetData = () => ({
        id: "",
        firstName: '',
        lastName: '',
        name: '',
        email: '',
        phone: '',
        country: '',
        address: '',
        county: '',
        postalCode: '',
        username: '',
        genderId: null,
        dateOfBirth: null,
        nationality: null,
        fines: []
    });

    const resetUserCartData = () => ({
        id: 0,
        isActive: false,
        paidDate: ""
    });

    const [checked, setIsChecked] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [data, setData] = useState<IUserProfileManage>(resetData);
    const [userProfileImg, setUserProfileImg] = useState();
    const [userCartData, setUserCartData] = useState<IUserCartData>(resetUserCartData);
    const [activeIndex, setActiveIndex] = useState<number | null>(null);

    const [isLicensesOpen, setIsLicensesOpen] = useState(false);
    const [isInsurancesOpen, setIsInsurancesOpen] = useState(false);

    const [isQuestionnaireOpen, setIsQuestionnaireOpen] = useState(false);
    const [isQuestionnaireLoading, setIsQuestionnaireLoading] = useState(true);
    const [questionnaires, setQuestionnaires] = useState([]);

    const userNavs = [
        { name: "Personal Information", action: () => { navigate(""); } },
        { name: "Competition Licence Application", action: () => { navigate("CompetitionLicenceApplication"); } },
        { name: "All Events", action: () => { navigate(`Events`); } },
        { name: "My Uploads", action: () => { navigate(`Uploads`); } },
        { name: "My Motor Licences", action: () => { navigate(`MotorLicences`); } },
        { name: "My Official Licences", action: () => { navigate(`OfficialLicenses`); } },
        { name: "My Forms", action: () => { navigate(`Forms`); } },
        { name: "My Fines", action: () => { navigate(`Fines`); } },
        // { name: "My Events", action: () => { navigate(`UserEvents`); } },
        { name: "Insurance", action: () => { navigate(`Insurance`); } },
        { name: "Media Forms", action: () => { navigate(`Media`); } },
        { name: "Minor Entrant", action: () => { navigate(`MinorEntrant`); } },
        { name: "One Event Pass", action: () => { navigate(`OneDayEvent`); } },
    ]

    const filteredUserNavs = userNavs.filter(nav => {
        if (data.fines.length == 0 && nav.name === "My Fines") {
            return false;
        }
        return true;
    });

    const organiserNavs = [...filteredUserNavs, { name: "My Events", action: () => { navigate(`UserEvents`); } }]

    useEffect(() => {
        QRCode.toCanvas(document.getElementById('canvas'), window.location.href, {
            margin: 2,
        }, (error: any) => {
            if (error) console.error(error)
        })
    }, []);

    useEffect(() => {
        if (data) {
            document.title = data.lastName + " " + data.firstName;
        }
    }, [data]);

    useEffect(() => {
        return () => {
            document.title = "Motorsport Ireland";
        };
    }, []);

    useEffect(() => {
        fetchData(userId || accountService.currentUserValue.id);
        fetchUserImg(userId || accountService.currentUserValue.id);
    }, []);

    useEffect(() => {
        if (isQuestionnaireOpen && !questionnaires.length) {
            fetchQuestionnaires();
        }
    }, [isQuestionnaireOpen]);

    function fetchQuestionnaires() {

        setIsQuestionnaireLoading(true)
        return formTemplateService
            .getAllByType(FormTemplateTypeEnum.Questionnaire, FormStatusEnum.Approved)
            .then(
                (json) => {
                    setQuestionnaires(json)
                }, handleErrorResponse
            )
            .finally(() => {
                setIsQuestionnaireLoading(false);
            });
    }

    function fetchData(id: string) {

        setIsLoading(true)
        return userInformationService
            .get(id)
            .then(
                (json) => {
                    setData(_data => { _data.role = json.roles; return { ..._data, ...json } });
                    if (json.fines.length > 0) {
                        setUserCartData(__data => {
                            __data.id = json.fines[json.fines.length - 1].userCartId;
                            __data.isActive = json.fines[0].userCartIsActive;
                            __data.paidDate = json.fines[json.fines.length - 1].userCartPaidDate;
                            return { ...__data }
                        });

                    }
                }, handleErrorResponse
            )
            .finally(() => {
                setIsLoading(false);
            });
    }

    function fetchUserImg(id: string) {

        setIsLoading(true)
        return userInformationService
            .getProfileImage(id)
            .then(
                (json) => {
                    setUserProfileImg(json);
                }, handleErrorResponse
            )
            .finally(() => {
                setIsLoading(false);
            });
    }

    const totalFinesAmount = data.fines.filter(fine => !fine.isPaid && fine.isChargeable).reduce((acc, fine) => acc + fine.price, 0);
    const totalDurationBan = data.fines.reduce((acc, fine) => acc + (fine.durationBan || 0), 0);
    const isAnyIndefinitelyBanned = data.fines.some(fine => fine.isBannedIndefinitely);

    return (
        <>
            {/* <AppBarUser navItems={filteredUserNavs} /> */}
            <Grid container sx={{ maxWidth: 'xl', margin: { xs: '0px auto', md: '20px auto' } }}>
                {data.fines.length > 0 &&
                    <Grid item xs={12}>
                        <Alert severity="error">
                            <Typography color="error" sx={{ fontFamily: { xs: "20px", md: "26px" } }}>
                                {isAnyIndefinitelyBanned ? "Your account is suspended indefinitely." :
                                    !userCartData.isActive && !!userCartData.paidDate ?
                                        "Your account is suspended until " + getFutureDate(userCartData.paidDate, totalDurationBan) :
                                        `Your fines, totaling ${getMoneyFormat(totalFinesAmount)}, haven't been paid.`}
                            </Typography>
                            {totalFinesAmount > 0 &&
                                <Link
                                    component="button"
                                    variant="body2"
                                    onClick={() => {
                                        navigate(`/userCart/${userCartData.id}`)
                                    }}
                                >
                                    Pay Fines
                                </Link>
                            }
                        </Alert>
                    </Grid>
                }

                <Hidden mdDown>
                    <Grid item xs={12} sm={3}>

                        <Grid item xs={12}>
                            <Card sx={{ height: '350px', position: 'relative', display: 'flex', flexDirection: 'column', marginBottom: '10px' }}>
                                <Box
                                    sx={{
                                        height: '150px',
                                        backgroundColor: PRIMARY_COLOR[1],
                                        position: 'relative',
                                    }} />

                                <Avatar
                                    alt="User Name"
                                    src={"data:image/jpeg;charset=utf-8;base64," + userProfileImg}
                                    sx={{
                                        width: 120,
                                        height: 120,
                                        position: 'absolute',
                                        top: '150px',
                                        left: '50%',
                                        transform: 'translate(-50%, -50%)',
                                        border: '2px solid white',
                                        borderRadius: "0px"
                                    }} />

                                <CardContent sx={{ textAlign: 'center', mt: '60px' }}>
                                    <Typography variant="h5" color={PRIMARY_COLOR[1]}>{data.firstName} {data.lastName}</Typography>
                                    <Typography variant="body1"><a href={`mailto:${data.email}`}>{data.email}</a></Typography>
                                    <Typography variant="body1">{data.dateOfBirth ? getDate(data.dateOfBirth) : "-"} ({data.age ? data.age + "yo" : "???"})  {accountService.isAdmin && <IconButton color="inherit" onClick={() => { navigator.clipboard.writeText(data.dateOfBirth ? getDate(data.dateOfBirth) : ""); }}><Icon>content_copy</Icon></IconButton>}</Typography>

                                    {accountService.isAdmin &&
                                        <Typography><span style={{ color: ORANGE_COLOR }}>Status:</span> {data.userStatusName}</Typography>
                                    }

                                </CardContent>
                            </Card>
                        </Grid>


                        <Grid item xs={12} mb="8px">
                            <InfoManageLicenseButton />
                        </Grid>

                        <Grid item xs={12} mb="8px">
                            <UserProfilePageLicenseList />
                        </Grid>

                        <Grid item xs={12} mb="8px">

                            <Card sx={{ height: 'auto', sm: "0" }}>
                                <List>

                                    <ListItemButton key={"Personal Information"} onClick={(e) => { setActiveIndex(0); navigate(""); }}>
                                        <ListItemIcon sx={{ minWidth: "40px" }}>
                                            <Icon>person</Icon>
                                        </ListItemIcon>
                                        <ListItemText primary="Personal Information" />
                                    </ListItemButton>

                                    <ListItemButton key={"Licenses"} onClick={(e) => setIsLicensesOpen(!isLicensesOpen)}>
                                        <ListItemIcon sx={{ minWidth: "40px" }}>
                                            <Icon>assignment_turned_in</Icon>
                                        </ListItemIcon>
                                        <ListItemText primary="Licences" />
                                        {isLicensesOpen ? <ExpandMore /> : <Icon>chevron_right</Icon>}
                                    </ListItemButton>

                                    <Collapse in={isLicensesOpen} timeout="auto" unmountOnExit>
                                        <List component="div">

                                            <ListItemButton sx={{ pl: 4, marginLeft: '26px', paddingLeft: '12px', borderLeft: '1px solid #deded3', bgcolor: LIGHT_GREY_COLOR }} onClick={e => navigate("MotorLicences")}>
                                                <ListItemIcon sx={{ minWidth: "40px" }}>
                                                    <Icon fontSize="small" color="disabled">directions_car</Icon>
                                                </ListItemIcon>

                                                <ListItemText
                                                    primaryTypographyProps={{ fontSize: '14px' }}
                                                    primary={"Competition"} />
                                            </ListItemButton>

                                            <ListItemButton sx={{ pl: 4, marginLeft: '26px', paddingLeft: '12px', borderLeft: '1px solid #deded3', bgcolor: LIGHT_GREY_COLOR }} onClick={e => navigate("OfficialLicences")}>
                                                <ListItemIcon sx={{ minWidth: "40px" }}>
                                                    <Icon fontSize="small" color="disabled">accessibility</Icon>
                                                </ListItemIcon>

                                                <ListItemText
                                                    primaryTypographyProps={{ fontSize: '14px' }}
                                                    primary={"Official"} />
                                            </ListItemButton>

                                            <ListItemButton sx={{ pl: 4, marginLeft: '26px', paddingLeft: '12px', borderLeft: '1px solid #deded3', bgcolor: LIGHT_GREY_COLOR }} onClick={e => navigate("Media")}>
                                                <ListItemIcon sx={{ minWidth: "40px" }}>
                                                    <Icon fontSize="small" color="disabled">radio</Icon>
                                                </ListItemIcon>

                                                <ListItemText
                                                    primaryTypographyProps={{ fontSize: '14px' }}
                                                    primary={"Media"} />
                                            </ListItemButton>

                                            <ListItemButton sx={{ pl: 4, marginLeft: '26px', paddingLeft: '12px', borderLeft: '1px solid #deded3', bgcolor: LIGHT_GREY_COLOR }} onClick={e => navigate("MinorEntrant")}>
                                                <ListItemIcon sx={{ minWidth: "40px" }}>
                                                    <Icon fontSize="small" color="disabled">supervisor_account</Icon>
                                                </ListItemIcon>

                                                <ListItemText
                                                    primaryTypographyProps={{ fontSize: '14px' }}
                                                    primary={"Minor Entrant"} />
                                            </ListItemButton>

                                            <ListItemButton sx={{ pl: 4, marginLeft: '26px', paddingLeft: '12px', borderLeft: '1px solid #deded3', bgcolor: LIGHT_GREY_COLOR }} onClick={e => navigate("OneDayEvent")}>
                                                <ListItemIcon sx={{ minWidth: "40px" }}>
                                                    <Icon fontSize="small" color="disabled">event</Icon>
                                                </ListItemIcon>

                                                <ListItemText
                                                    primaryTypographyProps={{ fontSize: '14px' }}
                                                    primary={"One Event"} />
                                            </ListItemButton>

                                        </List>
                                    </Collapse>

                                    <ListItemButton key={"Insurance"} onClick={(e) => setIsInsurancesOpen(!isInsurancesOpen)}>
                                        <ListItemIcon sx={{ minWidth: "40px" }}>
                                            <Icon>car_crash</Icon>
                                        </ListItemIcon>
                                        <ListItemText primary="Insurance" />
                                        {isInsurancesOpen ? <ExpandMore /> : <Icon>chevron_right</Icon>}
                                    </ListItemButton>

                                    <Collapse in={isInsurancesOpen} timeout="auto" unmountOnExit>
                                        <List component="div">

                                            <ListItemButton sx={{ pl: 4, marginLeft: '26px', paddingLeft: '12px', borderLeft: '1px solid #deded3', bgcolor: LIGHT_GREY_COLOR }} onClick={e => navigate("insurance/IRDS")}>
                                                <ListItemIcon sx={{ minWidth: "40px" }}>
                                                    <Icon fontSize="small" color="disabled">attach_money</Icon>
                                                </ListItemIcon>

                                                <ListItemText
                                                    primaryTypographyProps={{ fontSize: '14px' }}
                                                    primary={"IRDS"} />
                                            </ListItemButton>

                                            <ListItemButton sx={{ pl: 4, marginLeft: '26px', paddingLeft: '12px', borderLeft: '1px solid #deded3', bgcolor: LIGHT_GREY_COLOR }} onClick={e => navigate("insurance/BRDS")}>
                                                <ListItemIcon sx={{ minWidth: "40px" }}>
                                                    <Icon fontSize="small" color="disabled">attach_money</Icon>
                                                </ListItemIcon>

                                                <ListItemText
                                                    primaryTypographyProps={{ fontSize: '14px' }}
                                                    primary={"BRDS"} />
                                            </ListItemButton>

                                        </List>
                                    </Collapse>

                                    <ListItemButton key={"My Forms"} onClick={(e) => { setActiveIndex(0); navigate("Forms"); }}>
                                        <ListItemIcon sx={{ minWidth: "40px" }}>
                                            <Icon>article</Icon>
                                        </ListItemIcon>
                                        <ListItemText primary="My Forms" />
                                    </ListItemButton>

                                    <ListItemButton key={"Uploaded Files"} onClick={(e) => { setActiveIndex(0); navigate("Uploads"); }}>
                                        <ListItemIcon sx={{ minWidth: "40px" }}>
                                            <Icon>drive_folder_upload</Icon>
                                        </ListItemIcon>
                                        <ListItemText primary="Uploaded Files" />
                                    </ListItemButton>

                                    <ListItemButton key={"Personal Information Events"} onClick={(e) => { setActiveIndex(0); navigate("Events"); }}>
                                        <ListItemIcon sx={{ minWidth: "40px" }}>
                                            <Icon>emoji_events</Icon>
                                        </ListItemIcon>
                                        <ListItemText primary="Events" />
                                    </ListItemButton>

                                    <ListItemButton key={"Credit Points"} onClick={(e) => { setActiveIndex(0); navigate("UserCredits"); }}>
                                        <ListItemIcon sx={{ minWidth: "40px" }}>
                                            <Icon>credit_score</Icon>
                                        </ListItemIcon>
                                        <ListItemText primary="Credit Points" />
                                    </ListItemButton>

                                    <ListItemButton key={"Questionnaire"} onClick={(e) => setIsQuestionnaireOpen(!isQuestionnaireOpen)}>
                                        <ListItemIcon sx={{ minWidth: "40px" }}>
                                            <Icon>question_answer</Icon>
                                        </ListItemIcon>
                                        <ListItemText primary="Questionnaire" />
                                        {isQuestionnaireOpen ? <ExpandMore /> : <Icon>chevron_right</Icon>}
                                    </ListItemButton>

                                    <Collapse in={isQuestionnaireOpen} timeout="auto" unmountOnExit>
                                        <List component="div">

                                            {isQuestionnaireLoading && <LinearProgress />}
                                            {(!isQuestionnaireLoading && questionnaires?.length < 1) && <p>No available questionnaires</p>}
                                            {(!isQuestionnaireLoading && questionnaires.length > 0) && questionnaires.map((q: any) =>
                                                <ListItemButton sx={{ pl: 4, marginLeft: '26px', paddingLeft: '12px', borderLeft: '1px solid #deded3', bgcolor: LIGHT_GREY_COLOR }} onClick={e => navigate("Questionnaire/" + q.name)}>
                                                    <ListItemIcon sx={{ minWidth: "40px" }}>
                                                        <Icon fontSize="small" color="disabled">psychology_alt</Icon>
                                                    </ListItemIcon>

                                                    <ListItemText
                                                        primaryTypographyProps={{ fontSize: '14px' }}
                                                        primary={q.name} />
                                                </ListItemButton>
                                            )}

                                        </List>
                                    </Collapse>

                                    {(data && data.fines && data.fines.length > 0) &&
                                        <ListItemButton key={"Fines"} onClick={(e) => { setActiveIndex(0); navigate("Fines"); }}>
                                            <ListItemIcon sx={{ minWidth: "40px" }}>
                                                <Icon>gavel</Icon>
                                            </ListItemIcon>
                                            <ListItemText primary="Fines" />
                                        </ListItemButton>
                                    }

                                </List>
                            </Card>

                        </Grid>
                    </Grid>
                </Hidden>

                <Grid item xs={12} md={9} style={{ paddingLeft: "0px" }}>
                    <Grid container style={{ padding: "0px" }}>


                        <Hidden mdUp>
                            <Grid item xs={12} md={12} style={{ padding: "0px" }}>
                                <Outlet></Outlet>
                            </Grid>
                        </Hidden>

                        <Hidden mdDown>
                            <Grid item xs={12} md={12} style={{ padding: "8px" }}>
                                <Outlet></Outlet>
                            </Grid>
                        </Hidden>
                    </Grid>

                </Grid>

            </Grid >
        </>
    );

}
